export const Surendranagar = {
    title: "Surendranagar",
    title1: "(Cultural and Commercial Hub)",

    intro: "Surendranagar, a city in Gujarat, is known for its vibrant culture, historical significance, and commercial importance. It serves as a trade center for agricultural products and textiles, while also offering glimpses of Gujarat's rich history and heritage.",

    attractions: [
        {
            name: "Lakhota Lake",
            description: "Lakhota Lake is a serene and picturesque lake located in the heart of Surendranagar. It offers a peaceful environment, perfect for evening strolls and relaxation. The lake also has a temple in the middle, adding to its charm and spiritual significance.",
            location: "Lakhota Lake, Surendranagar, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Relax by the lake and enjoy the peaceful surroundings",
                "Take a boat ride on the lake",
                "Engage in photography of the beautiful landscape",
                "Enjoy a walk along the lake’s path",
                "Visit the temple located in the middle of the lake"
            ],
            mapLink: "https://maps.app.goo.gl/ZVFFV5YoVtT4UGwZ9",
        },
        {
            name: "Ranchhodray Mandir",
            description: "Ranchhodray Mandir is a historical temple dedicated to Lord Krishna. The temple is known for its religious significance and architectural beauty, attracting numerous pilgrims and tourists alike.",
            location: "Ranchhodray Mandir, Surendranagar, Gujarat",
            timings: "5:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend aarti and prayer sessions",
                "Meditate and enjoy the spiritual ambiance",
                "Admire the intricate carvings and architecture",
                "Engage with locals and learn about the temple’s history",
                "Explore the temple complex and surrounding areas"
            ],
            mapLink: "https://maps.app.goo.gl/7kZXWV6WrWZToKNX6",
        },
        {
            name: "Wadhwan Lake",
            description: "Wadhwan Lake is a popular spot for nature lovers and birdwatchers. The lake is surrounded by lush greenery and offers a tranquil environment, ideal for birdwatching and nature walks.",
            location: "Wadhwan Lake, Surendranagar, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Birdwatching and nature photography",
                "Take a leisurely walk around the lake",
                "Enjoy the calm and peaceful environment",
                "Engage in meditation by the lake",
                "Admire the surrounding natural beauty"
            ],
            mapLink: "https://maps.app.goo.gl/8Vpvq12fV2VptAK28",
        },
        {
            name: "Jain Temples of Surendranagar",
            description: "Surendranagar is home to several ancient Jain temples, known for their stunning architecture and spiritual significance. These temples are peaceful places to learn about Jainism and admire the beautiful carvings and design.",
            location: "Various Jain Temples, Surendranagar, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Admire the intricate carvings and architecture",
                "Learn about Jainism and its teachings",
                "Meditate in the peaceful temple surroundings",
                "Take photographs of the temple designs",
                "Attend prayer sessions and rituals"
            ],
            mapLink: "https://maps.app.goo.gl/Kyy7FcXWqZWdkAfw7",
        },
        {
            name: "Barda Hills",
            description: "Barda Hills, located near Surendranagar, is a wildlife sanctuary known for its scenic beauty and rich biodiversity. The sanctuary is home to various wildlife species, including leopards, wild boars, and a variety of birds.",
            location: "Barda Hills, Surendranagar, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "₹50 per person",
            bestTimeToVisit: "November to March",
            activities: [
                "Go on a wildlife safari",
                "Spot various animal species and birds",
                "Engage in nature walks",
                "Photography of the wildlife and landscape",
                "Enjoy the tranquility of the natural surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/cMNBm6JfYquv7oF78",
        },
        {
            name: "Surendranagar Agricultural Market",
            description: "The Surendranagar Agricultural Market is a bustling marketplace where traders and farmers sell agricultural products. It’s a great place to experience local life and buy fresh produce, spices, and textiles.",
            location: "Surendranagar Agricultural Market, Surendranagar, Gujarat",
            timings: "7:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Buy fresh produce and local products",
                "Engage with local farmers and traders",
                "Experience the vibrant marketplace atmosphere",
                "Take photographs of the market's lively environment",
                "Try traditional snacks and local delicacies"
            ],
            mapLink: "https://maps.app.goo.gl/dhXowchmj9s7DKx88",
        },
    ]
};
